<template>
    <v-container>
        <div class="d-flex flex-column align-center justify-center py-4">
            <v-icon size="64" color="#551ebb" class="mb-4">mdi-cloud-upload-outline</v-icon>
            <h3 class="text-h6 font-weight-medium mb-2 text-center" style="color: #2c3e50;">
                Carregar Logótipo
            </h3>
            <p class="text-body-2 grey--text mb-6 text-center">
                Recomendamos imagens PNG com fundo transparente.
            </p>
            
            <div class="upload-wrapper">
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" 
                    v-on:vdropzone-file-added="fileAdded"
                    v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                ></vue-dropzone>
                <div class="preview"></div>
            </div>
        </div>
    </v-container>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
            vueDropzone: vue2Dropzone
        },

        methods: {
            fileAdded(file) {
                this.$root.state.upload.img = URL.createObjectURL(file)
                this.$root.state.upload.name = file.name
            },

            maxFilesExceeded(file) {
                this.$refs.myVueDropzone.removeAllFiles()
                this.$refs.myVueDropzone.addFile(file)
            }
        },

        data() {
            return {
                dropzoneOptions: {
                    url: 'https://httpbin.org/post',
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    acceptedFiles: 'image/*',
                    maxFilesize: 30,
                    uploadMultiple: false,
                    maxFiles: 1,
                    autoProcessQueue: false,
                    duplicateCheck: false,
                    addRemoveLinks: false,
                    dictDefaultMessage: 'Arraste e solte a imagem, ou clique aqui',
                    disablePreviews: true,
                    previewsContainer: ".preview"
                }
            }
        }
    }
</script>

<style>
.upload-wrapper {
    width: 100%;
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    overflow: hidden;
    background-color: #f8fafc;
    transition: all 0.3s ease;
}

.upload-wrapper:hover {
    border-color: #551ebb;
}

.dropzone {
    font-family: Roboto, sans-serif;
    margin: 0 auto;
    background: transparent;
    border: none;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.dropzone.dz-drag-hover {
    background-image: linear-gradient(45deg, #ffffff 25%, #551ebb1a 25%, #551ebb1a 50%, #ffffff 50%, #ffffff 75%, #551ebb1a 75%, #551ebb1a 100%);
    background-size: 42.43px 42.43px;
}

.preview {
    display: none;
}

.dropzone .dz-preview .dz-image {
    z-index: initial;
}

.dropzone .dz-preview .dz-image img {
    margin: 0 auto;
}

.dropzone .dz-preview {
    left: 50%;
    transform: translateX(-50%);
}

.dropzone .dz-preview.dz-image-preview {
    background: none;
}

#dropzone .dz-preview .dz-details, 
#dropzone .dz-preview .dz-progress, 
#dropzone .dz-preview .dz-remove {
    display: none;
}
</style>